import CardsViewSkeletonCard from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewSkeletonCard/CardsViewSkeletonCard"
import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"

import styles from "./CardsViewLoadingState.module.scss"

const LOADING_CARD_COUNT = 3

export default function CardsViewLoadingState() {
    const { tabContentName } = useObjectsView()

    return (
        <div className={styles.base} aria-label={`${tabContentName} List Loading`} role="tabpanel">
            {Array.from({ length: LOADING_CARD_COUNT }).map((_, index) => (
                <CardsViewSkeletonCard key={index} />
            ))}
        </div>
    )
}
